import Leaderboard from ".";

export const leaderboardRoutes = () => [
  {
    path: "/admin/leaderboard",
    title: "Leaderboard Management",
    layout: "admin",
    routeType: "admin",
    component: Leaderboard,
  },
]